/**
 * mwApp.sets module <br>
 * Work with category sets, categories and subcategories: show/add/edit/remove
 *
 * @namespace mwApp/sets
 */

import AddCategoryCtrl from './addCategory.controller'
import AddCategorySetCtrl from './addCategorySet.controller'
import AddChannelsCtrl from './addChannels.controller'
import AddSubCategoryCtrl from './addSubCategory.controller'
import SetsCtrl from './sets.controller'
import {notInArray} from './sets.directives'
import setsConfig from './sets.config'

export default
angular.module('mwApp.sets', [])
  .config(setsConfig)
  .directive('notInArray', notInArray)
  .controller('SetsCtrl', SetsCtrl)
  .controller('AddCategorySetCtrl', AddCategorySetCtrl)
  .controller('AddCategoryCtrl', AddCategoryCtrl)
  .controller('AddSubCategoryCtrl', AddSubCategoryCtrl)
  .controller('AddChannelsCtrl', AddChannelsCtrl)
